export default __webpack_public_path__ + "static/media/162473__kastenfrosch__successful.2dc97209.mp3";